import * as React from "react";
import { ChangeEvent } from "react";

interface PropsType {
  id?: string;
  name?: string;
  onChange?(e: ChangeEvent<HTMLInputElement>): void;
  value: number | string;
}

export default function MoneyInput(props: PropsType): JSX.Element {
  return (
    <div className="input">
      <i className="fas fa-dollar-sign" />

      <input required type="text" {...props} />
    </div>
  );
}
